<template>
  <div class="home">
      <div class="mb-md">
		<el-input v-model="input" placeholder="请输入内容"></el-input>
		 
        <input type="file" accept=".xlsx"  @change="chageFile" ref="inputFile"/>
        <button class="blueBtn" @click="exportExcelBtn">导出xlsx</button><br /><br />
        <!-- <button v-if="bgbsm" class="blueBtn" @click="zxClicked">最新任务清单</button>
        <button v-if="!bgbsm" class="blueBtn" @click="editClicked">编辑</button>
        <button v-if="!bgbsm" class="blueBtn" @click="save">保存</button> -->
		<!-- <button  class="blueBtn" @click="savett">保存</button> -->
      </div>
	  
      <!--web spreadsheet组件-->
      <div class="excel">
        <!-- <div id="luckysheet"style="margin-top: 40px;" @keydown="onKeyDown"></div> -->
		<div id="luckysheet"style="margin-top: 40px;" v-on:keydown.enter="handlerEnterKey"></div>
      </div>
    </div>
</template>

<script>

// 引入依赖包
import LuckyExcel from 'luckyexcel'
const luckyexcel = window.luckysheet
// 代码见下
import { exportExcel } from './export.js'  

export default {
  name: 'HomeView',
  props: {
    bgbsm: {
      type: String
    }

  },
  data () {
    return {
      xs: null,
	  indexVal: 0,
	  inputText: '',
	  input:0,
      FormData: {}
    }
  },  
  mounted () {  
	  // window.addEventListener('keyup',this.handlerEnterKey);
	  
	  let inputVal='';
	  // window.addEventListener('keyup',function(e){
		  // this.homeValue = e.key;
		  //( e.key) 
		  // this.indexVal = JSON.stringify(e.key);
		  // this.indexVal+=e.key;
		  // $('#indexVal').val(e.key);
		  // console.info("----yyyyyyyyy------"+ this.indexVal);
		  // //  // event.preventDefault();
		  // // console.info('我按下了inputVal'+ inputVal);  
		  
		  //  const rangeAxis = luckysheet.getRangeAxis();
		  //  alert( e.key+'我按下了JSON.stringify#：'+JSON.stringify(rangeAxis)); 
		  //  const col = String(rangeAxis).charCodeAt(0) - 65; // 行 --ASCII码转换
		  //  const row = parseInt(String(rangeAxis).slice(1))-1; //列--- 减1是因为luckysheet的索引是从0开始的
		  //  console.info(col+'--------------------'+row);   
		   
		  //  luckysheet.setCellValue(2, 1,{
		  //             m: e.key, // 设置显示值
		  //             v: e.key, // 设置原始值
				// 	  ct: { fa: "@",t: "s"},
				// 	 // tb: 2,   // 文本超出格子，自动换行。自动编辑模式撑开高度时，高度会变得很高
				// 	  ht: 1, 
				// }
		  //  )
	   // }); 
	  // let data = luckysheet.toJson()
	  // console.log("--------"+JSON.stringify(data)) 
      //this.$message('2');
       luckysheet.create({
			 container: 'luckysheet', // luckysheet为容器id
			 lang: 'zh',
			 // cellEdit: true, // 启用单元格编辑功能
			 // cellFormat: 'text', // 将单元格视为文本格式
			 // numberFormat: {
				//  decimalSeparator: '.',
				//  groupSeparator: ',',
				//  precision: 0, // 设置精度为0，表示不限制小数位数
				//  allowDecimalZero: true // 允许小数点后出现零
			 // }
        });
		this.excelToInput()
  },
  // beforeDestroy() {
  //   window.removeEventListener('keyup', this.handleKeyUp)
  // },
  methods: { 
	  excelToInput(){
		 // alert(23);
		  // 获取Luckysheet中的数据范围
		  var rangeAxis = luckysheet.getRangeAxis();
		  alert(rangeAxis.length);
		  // 遍历数据范围，将每个单元格的值转换为input标签
		  for (var i = 0; i < rangeAxis.length; i++) {
		      for (var j = 0; j < rangeAxis[i].length; j++) {
		          // 获取单元格的值
		          var cellValue = rangeAxis[i][j];
				  
		          // 创建一个input标签
		          var inputElement = document.createElement('input');
		          // 设置input标签的属性
		          inputElement.type = 'text';
		          inputElement.value = cellValue;
		          inputElement.id = 'cell-' + i + '-' + j;
		          // 将input标签添加到容器中
		          document.getElementById('luckysheet').appendChild(inputElement);
		      }
		  }
	  },
	  // handlerEnterKey(e){
		 //  this.input+=e.key;
		 //   // this.$toast('这是一个消息弹窗提示:'+e.key); this.$message('这是一个消息弹窗提示:'+ this.indexVal);
	  // }, 
	  onKeyDown(event) {
		// 获取按键的值
		const key = event.key;
		// 更新输入内容
		if (key === 'Enter') {
		  this.inputText += '\n';
		} else if (key.length === 1) {
		  this.inputText += key;
		}
		// 输出按键信息
		alert('Key pressed:', key);
	  },
	  cellToRowCol(cell) {
	      const col = cell.charCodeAt(0) - 65; // ASCII码转换
	      const row = parseInt(cell.slice(1)) - 1; // 减1是因为luckysheet的索引是从0开始的
	      return { row, col };
	  }, 
	 // savett(){  
		// // 获取选中的单元格范围
		// const rangeAxis = luckysheet.getRangeAxis(); 
		// console.log("当前选中单元格的值为：" + rangeAxis);    
		// console.log("当前选中单元格的值this.cellToRowCol('A6')为：", this.cellToRowCol('A6'));   
	 // }, 
    // init () {
    //   const url = GLOBAL_CONFIG.stxf + '/hzqd/getBybsm'
    //   this.http.longPost(url, { bsm: this.bgbsm }).then((res) => {
    //     if (res) {
    //       this.FormData = JSON.parse(res.data)
    //        console.log('this.FormData',res.data);
    //       console.log('this.FormData', this.FormData)
    //       this.FormData.allowEdit = false
    //       this.FormData.showinfobar = false
    //       this.FormData.showtoolbar = false
    //       this.FormData.lang = 'zh'
    //       luckysheet.create(this.FormData)
    //     }
    //   })
    // },
    // save () {
    //   const data = luckysheet.toJson()
    //   // console.log(JSON.stringify(data))
    //   // localStorage.setItem('excel2', JSON.stringify(data))

    //   const url = GLOBAL_CONFIG.stxf + '/hzqd/save'
    //   this.http.post(url, { json: JSON.stringify(data) }).then((res) => {
    //     if (res && res.data) {
    //       this.$message.success('保存成功')
    //       this.init()
    //       this.$emit('getlsTable')
    //     }
    //   })
    // },
    // editClicked () {
    //   this.FormData.showtoolbar = true
    //   this.FormData.allowEdit = true
    //   luckysheet.create(this.FormData)
    // },
    // zxClicked () {
    //   this.bgbsm = ''
    //   this.init()
    // },
    exportExcelBtn () {
      // console.log(luckysheet.getluckysheetfile())
      exportExcel(luckysheet.getluckysheetfile(), '千分')
    },
    chageFile () {
      this.importExcel(this.$refs.inputFile.files[0])
      // let data = luckysheet.toJson()
      // console.log(JSON.stringify(data))
    },
    importExcel (file) {
      const name = file.name 
      // 获取文件后缀
      const suffixArr = name.split('.');
      const suffix = suffixArr[suffixArr.length - 1];
      if (suffix !== 'xlsx') {
        alert('目前只能导入xlsx类型的文件')
        return
      }
      LuckyExcel.transformExcelToLucky(file, this.fileCb, this.errorCb)
    },
    fileCb (exportJson, luckysheetfile) {
      // 转换后获取工作表数据
      if (exportJson.sheets === null || exportJson.sheets.length === 0) {
        alert('无法读取excel文件的内容，当前不支持xls文件!')
        return
      }
      // console.log('exportJson', exportJson)
      // console.log('luckysheetfile', luckysheetfile)
      luckysheet.destroy()
      luckysheet.create({
        container: 'luckysheet', // luckysheet is the container id
        showinfobar: false,
        data: exportJson.sheets,
        title: exportJson.info.name,
        userInfo: exportJson.info.name.creator
      })
	  // console.info("拿到数据："+ JSON.stringify(exportJson.sheets));
    },
    errorCb (error) {
      console.log("--------------"+error)
    }
  }
}
</script>

 <style>
#luckysheet {
  margin: 0px;
  padding: 0px;
  position: absolute;
  width: 100%;
  left: 0px;
  top: 30px;
  bottom: 0px;
}

#uploadBtn {
  font-size: 16px;
}

#tip {
  position: absolute;
  z-index: 1000000;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
}
  </style>
